import {IHttpService} from "angular";
import {Securities} from "../../instruments/types/CodeAndExchange";
import {TechnicalIndicatorsRecords} from "../types/TechnicalIndicatorsRecord";
import {ObjectUtil} from "../../js/util/ObjectUtil";

export class TechnicalIndicatorsService {

    public static readonly id = "technicalIndicatorsService";

    /** @ngInject */
    public constructor(private readonly $http: IHttpService) {

    }

    public async latest(securities: Securities): Promise<TechnicalIndicatorsRecords> {
        if (securities.length === 0) {
            return [];
        } else {
            const request = securities.map((s) => ObjectUtil.pick(s, "code", "exchange"));
            const url = "/tradefloor/api/technical-indicators";
            const response = await this.$http.post<TechnicalIndicatorsRecords>(url, request);
            return response.data;
        }
    }
}
